import styled from "styled-components";
import { dominant } from "@glossy";
import { TermClauseLabel } from "@radarly/models/clause/label";

export type LabelNode =
  | "default"
  | "equal"
  | "from"
  | "minmax"
  | "no-range"
  | "to";

export const Label = styled.span<{ excluded?: boolean; colorized?: boolean }>`
  text-decoration: ${({ excluded }) => excluded && "line-through"};
  color: ${(props) => props.colorized && !props.excluded && dominant(props)};
`;

export function formatTermClauseLabel({ label, type }: TermClauseLabel) {
  if (type === "hashtags") {
    return `#${label}`;
  } else if (type === "mentions") {
    return `@${label}`;
  } else if (type === "entities") {
    return label.replace(/\./g, " ");
  } else {
    return label;
  }
}
